import React from 'react';
import PropTypes from 'prop-types';
import UserDatabases from '@Services/UserDatabases';
import { ButtonWithIcon } from '@els/els-react--button';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import ExportModalContentTooltip from './ExportModalContentTooltip';
import { SELECT_DATA_EXPORT_OPTION } from '../../ExportModalConstants';

import './ExportModalContentExports.scss';

// Prevent warning from Leyden
RadioButtonGroup.Option.propTypes.label = PropTypes.oneOfType([PropTypes.string, PropTypes.node]);

function ExportModalContentExports({ data, isSelectionExportActive, openDatapointsView, setExport, parentParams }) {
  const { databaseId } = parentParams;

  const isSelectDataOption = (option) => option.name === SELECT_DATA_EXPORT_OPTION;

  const isReaxysContent = databaseId === '20' || UserDatabases.isDefaultDatabase(databaseId);

  if (!isReaxysContent || !data.exports.length) {
    return null;
  }

  return (
    <div className="exportModal__exports">
      <div className="exportModal__content_row">
        <div className="exportModal__content_row_label">Export:</div>
        <div className="exportModal__content_row_value exportModal__exports_value">
          <RadioButtonGroup
            shouldBeSelectedByDefault={false}
            onChange={(event) => {
              const { value: indexStr } = event.currentTarget;
              setExport(Number(indexStr));
            }}
            a11y={{ name: 'Select an option' }}
            shouldHideLabel>
            {data.exports.map((exportItem, index) => (
              <RadioButtonGroup.Option
                // eslint-disable-next-line react/no-array-index-key
                key={`${index}-${exportItem.label}`}
                id={`export-radio-button-${index}-${exportItem.label}`}
                className="exportModal__exports_value_item u-els-margin-left-none"
                value={`${index}`}
                checked={exportItem.checked}
                label={
                  <div>
                    {exportItem.label}
                    {isSelectDataOption(exportItem) && isSelectionExportActive && (
                      <ButtonWithIcon
                        type="link"
                        sprite="Plus"
                        linkIconSize="xs"
                        className="e2e-export-modal-content-add-datapoints u-els-margin-top-1o2"
                        onClick={openDatapointsView}>
                        Add datapoints
                      </ButtonWithIcon>
                    )}
                  </div>
                }
              />
            ))}
          </RadioButtonGroup>
        </div>
        <div className="exportModal__content_row_tooltip">
          {data.exports.map((exportItem) => (
            <ExportModalContentTooltip key={exportItem.name} name={exportItem.name} header={exportItem.label} text={exportItem.tooltip} />
          ))}
        </div>
      </div>
    </div>
  );
}

ExportModalContentExports.propTypes = {
  data: PropTypes.object,
  parentParams: PropTypes.object,
  isSelectionExportActive: PropTypes.bool,
  openDatapointsView: PropTypes.func.isRequired,
  setExport: PropTypes.func.isRequired,
};

export default ExportModalContentExports;
